import React, { memo } from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import WaveLayerCountListItem from './WaveLayerCountListItem';
import { WAVE_STYLE } from '../../../../Preview/PreviewDisplayConstants';
import CondensedListItem from '../../../../../../list-items/CondensedListItem';
import WaveLayerBarWidth from './WaveLayerBarWidth';
import WaveLayerPointRadius from './WaveLayerPointRadius';

const RenderCondensedList = ({ firstListItem, secondListItem }) => {
    return (
        <CondensedListItem
            elements={[
                {
                    width: 6,
                    component: firstListItem
                },
                {
                    width: 6,
                    component: secondListItem
                },
            ]}
        />
    );
}

const WaveLayerParticleSettingsListItem = memo((props) => {
    const { waveStyle, index } = props;

    // Line draws a continuous wave like Solid, so it takes the same Point Count control (and no width
    // control) — mirroring the global Shape settings, where Solid and Line both expose only Point Count.
    if (waveStyle === WAVE_STYLE.SOLID || waveStyle === WAVE_STYLE.LINE)
        return <WaveLayerCountListItem index={index} />

    if (waveStyle === WAVE_STYLE.BAR) {
        return <RenderCondensedList
            firstListItem={<WaveLayerCountListItem index={index} />}
            secondListItem={<WaveLayerBarWidth index={index} />}
        />
    }

    if (waveStyle === WAVE_STYLE.POINT) {
        return <RenderCondensedList
            firstListItem={<WaveLayerCountListItem index={index} />}
            secondListItem={<WaveLayerPointRadius index={index} />}
        />
    }
});

const mapStateToProps = (state, { index }) => {
    const waveStyle = state.createPreview.present.videoSettings.visualizer.waveCircles[index].customOptions.waveStyle;
    return { waveStyle };
};

const mapDispatchToProps = (dispatch) => ({
    updateWaveLayerCustomOptions: (index, key, value) => dispatch(createActions.updateWaveLayerCustomOptions(index, key, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(WaveLayerParticleSettingsListItem);